module.exports = __webpack_public_path__ + "static/ΑΑ_POIOTIKOS_WEB_GR-0732c951bbabe261aaa98e7c1eb4c440.pdf";